(function () {
	'use strict';

	angular
	.module('core')
	.directive('focusIf', focusIf);

	focusIf.$inject = ['$sce', '$timeout'];

	function focusIf($sce, $timeout) {
		return {
			restrict: 'A',
			scope:{
					'trigger':'=focusIf'
			},
			link: function($scope, elem) {
				$scope.$watch('trigger', function(value) {
					if(value === true) {
						$timeout(function(){
							elem[0].focus();
						}, 50);
					}
				});
			}
		}
	}
})();